<h1 mat-dialog-title>
  {{data?.title}}
  <a class="mat-dialog-close-button"
     mat-icon-button
     [mat-dialog-close]="true"
     tabindex="0">
    <mat-icon color="warn">close</mat-icon>
  </a>
</h1>
<div mat-dialog-content
     class="py-2">
  <ng-container *ngIf="data?.media.url">
    <img *ngIf="data.media.type === MediaTypeEnum.Image && data.media.url"
         [src]="data.media.url">
    <video *ngIf="data.media.type === MediaTypeEnum.Video && data.media.url"
           [src]="data.media.url"
           controls></video>
  </ng-container>
  <p *ngIf="!data?.media.url">
    Media kunde inte visas... filinformation saknas eller är felaktig.
  </p>
</div>
